// src/pages/hbim-articles.js

import Link from "next/link";
import React, { useState, useEffect } from "react";
import NewsItem from "../../components/blog/news_item copy"; // Ensure this component is designed for HBIM Articles
import Meta from "../../components/Meta";
import { HeadLine } from "../../components/component";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../../config/fireabseConfig"; // Ensure correct path

const HbimArticles = () => {
  const [hbimArticles, setHbimArticles] = useState([]);
  const [displayedArticles, setDisplayedArticles] = useState([]);
  const [loadMoreBtn, setLoadMoreBtn] = useState(true);
  const [loading, setLoading] = useState(true); // Initialize loading state

  useEffect(() => {
    // Fetch HBIMArticles from Firestore
    const fetchHbimArticles = async () => {
      try {
        const hbimCollection = collection(db, "hbimArticles");
        const q = query(hbimCollection, orderBy("createdAt", "desc")); // Order by creation date
        const snapshot = await getDocs(q);
        const articles = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setHbimArticles(articles);
        setDisplayedArticles(articles.slice(0, 6)); // Initially show 6 articles
      } catch (error) {
        console.error("Error fetching HBIMArticles:", error);
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };

    fetchHbimArticles();
  }, []);

  const handleLoadMore = () => {
    setDisplayedArticles(hbimArticles); // Show all articles
    setLoadMoreBtn(false); // Hide the Load More button
  };

  return (
    <>
      <Meta title="HBIM Articles || GMJA Arc-Hive | Preserving Architectural Heritage" />
      {/* HBIM Articles Section */}
      <section className="relative py-24 bg-gray-50 dark:bg-jacarta-900">
        <picture className="pointer-events-none absolute inset-0 -z-10">
          <img
            src="/images/gradient_light.jpg"
            alt="gradient"
            className="h-full w-full object-cover"
          />
        </picture>
        <div className="container mx-auto px-4">
          {/* Headline */}
          <HeadLine
            text="Explore HBIM Articles"
            classes="font-display text-jacarta-700 mb-12 mt-12 text-center text-4xl font-medium dark:text-white"
          />

          {loading ? (
            // Loading Skeleton
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3">
              {[...Array(6)].map((_, index) => (
                <div
                  key={index}
                  className="rounded-2xl overflow-hidden bg-gray-200 animate-pulse"
                >
                  <div className="h-48 bg-gray-300"></div>
                  <div className="p-4">
                    <div className="h-6 bg-gray-300 rounded w-3/4 mb-2"></div>
                    <div className="h-4 bg-gray-300 rounded w-full mb-4"></div>
                    <div className="h-4 bg-gray-300 rounded w-1/2"></div>
                    <div className="mt-4 h-4 bg-gray-300 rounded w-24"></div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            // Render News Items
            <NewsItem data={displayedArticles} />
          )}

          {/* Load More */}
          {!loading && loadMoreBtn && hbimArticles.length > 6 && (
            <div className="mt-10 text-center">
              <button
                onClick={handleLoadMore}
                className="bg-green-500 shadow-lg hover:bg-green-600 inline-block rounded-full py-3 px-8 text-center font-semibold text-white transition-all"
              >
                Load More
              </button>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default HbimArticles;
